<script setup lang="ts">
definePageMeta({
  title: 'FAQ',
})
</script>

<template>
  <div class="py-24 bg-gray-50 dark:bg-gray-950 min-h-screen">
    <UContainer class="max-w-3xl">
      <div class="text-center mb-16">
        <h1 class="text-4xl font-bold text-gray-900 dark:text-white mb-4">
          Frequently Asked Questions
        </h1>
        <p class="text-gray-600 dark:text-gray-400 text-lg">
          Everything you need to know about TCF Canada and our learning approach.
        </p>
      </div>

      <div class="space-y-4">
        <UAccordion :items="LANDING_CONTENT.FAQ as any" variant="soft" size="lg" />
      </div>

      <div class="mt-16 text-center">
        <p class="text-gray-600 dark:text-gray-400 mb-4">Still have questions?</p>
        <UButton :to="ROUTES.CONTACT" color="primary" variant="soft" size="lg"
          >Contact Support</UButton
        >
      </div>
    </UContainer>
  </div>
</template>
